export default "__VITE_ASSET__DAdKOfhx__"